import React from "react";
import PropTypes from "prop-types";

import Chat from "../../components/Chat";

export default class HelpPage extends React.Component {
  static propTypes = {
    token: PropTypes.string
  };

  render() {
    return (
      <Chat
        token={this.props.token}
        url="chat/help_chatroom"
        room="help_chatroom"
        show_input={true}
      />
    );
  }
}
